import api from './Api';

const avatars = new Map();
window.addEventListener('pwf-profile-picture-changed', event => {
    const playerId = event.detail?.playerId;
    if (!playerId) avatars.clear();
    else for (const key of avatars.keys()) if (key.endsWith(`:${playerId}`)) avatars.delete(key);
});
window.addEventListener('pwf-room-membership-ended', () => avatars.clear());
export const getRoomAvatar = (roomId, playerId) => {
    const key = `${roomId}:${playerId}`;
    const cached = avatars.get(key);
    if (cached) return cached.promise;
    if (avatars.size > 256) avatars.clear();
    const promise = api.get(`/api/profiles/room/${encodeURIComponent(roomId)}/${encodeURIComponent(playerId)}`)
        .then(response => response?.data).catch(error => {
            if (avatars.get(key)?.promise === promise) avatars.delete(key);
            throw error;
        });
    avatars.set(key, { time: Date.now(), promise });
    return promise;
};
export const uploadProfilePicture = async dataUrl => (await api.post('/api/profiles/picture', { dataUrl }))?.data;
export const deleteProfilePicture = () => api.delete('/api/profiles/picture');

export async function prepareProfilePicture(file) {
    if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) throw new Error('INVALID_PROFILE_PICTURE');
    const source = URL.createObjectURL(file);
    try {
        const image = await new Promise((resolve, reject) => {
            const img = new Image(); img.onload = () => resolve(img); img.onerror = () => reject(new Error('INVALID_PROFILE_PICTURE')); img.src = source;
        });
        const scale = Math.min(1, 192 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        const context = canvas.getContext('2d');
        context.fillStyle = '#ffffff'; context.fillRect(0,0,canvas.width,canvas.height);
        context.drawImage(image, 0,0,canvas.width,canvas.height);
        let quality = .75;
        let dataUrl = canvas.toDataURL('image/jpeg', quality);
        while (dataUrl.length > 43000 && quality > .4) {
            quality -= .1;
            dataUrl = canvas.toDataURL('image/jpeg', quality);
        }
        if (dataUrl.length > 43000) throw new Error('INVALID_PROFILE_PICTURE');
        return dataUrl;
    } finally { URL.revokeObjectURL(source); }
}
